// Production: Secure mode
export const SecurityStatus = "0"; // 🔐 ENCRYPTED
// Development/Testing: Plain mode  
// export const SecurityStatus = "1"; // 🔓 PLAIN TEXT
export const SECRET_KEY_Storage="Init@SecureLocalStorage"

export const DirectDeduct = process.env.REACT_APP_DEDUCTION_DIRECT_HALFDAY;
console.log("endpoint is", process.env);

